import { makeStyles } from "@mui/styles";
import { Button, ButtonVariation } from "components/Button/Button";
import { Popover } from "components/Popover/Popover";
import { ReactNode } from "react";
import "./Prompt.scss";

interface ModalPromptProps {
    isOpen: boolean;
    titleText: string;
    cancelButtonText?: string;
    cancelButtonVariation?: ButtonVariation;
    confirmButtonText: string;
    confirmButtonVariation?: ButtonVariation;
    onCancel: () => void;
    onConfirm?: () => void;
    rootStyle?: any;
    additionalActionButton?: ReactNode;
}

export const ModalPrompt = ({
    isOpen,
    titleText,
    cancelButtonText = "Cancel",
    cancelButtonVariation = "primary",
    confirmButtonText,
    confirmButtonVariation = "white",
    onCancel,
    onConfirm,
    rootStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    additionalActionButton,
}: ModalPromptProps) => {
    const useStyles = makeStyles(() => ({
        rootStyle,
    }));
    const classes = useStyles();

    return (
        <Popover isOpen={isOpen} anchorReference="none" classes={{ root: classes.rootStyle }}>
            <div className="popover-content">
                <div>{titleText}</div>
                <div className="button-container">
                    <Button
                        variation={cancelButtonVariation}
                        onClick={onCancel}
                        label={cancelButtonText}
                        autoFocus
                    />
                    {onConfirm && (
                        <Button
                            variation={confirmButtonVariation}
                            onClick={onConfirm}
                            label={confirmButtonText}
                        />
                    )}
                    {additionalActionButton}
                </div>
            </div>
        </Popover>
    );
};
